import { Visibility } from './visibility';
import { translation } from '@cue/translations';

export const visibilities: Visibility[] = [
  {
    value: 'public',
    text: translation.reservationPopup.visibility.public,
  },
  {
    value: 'private',
    text: translation.reservationPopup.visibility.private,
  },
];
